import React from 'react';

export default function Notify({ type, text, action }) {
    return (
        <div className={`notify ${type ? type : ''} ${action ? action : ''}`}>
            <h2>{text}</h2>
        </div>
    )
}
